export default __webpack_public_path__ + "static/media/22.6ae1b724.png";